// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const PaperAirplaneIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "PaperAirplane/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m12 19 9 2-9-18-9 18 9-2Zm0 0v-8"
}));
export default PaperAirplaneIcon;